/* Velvet Room — Maison de Chris 2026 — theme runtime (vanilla, no deps) */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const MDC = window.MDC || { routes: {}, settings: {}, strings: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Money ---------- */
  const money = (cents) => {
    const fmt = MDC.money || '{{amount}}';
    const amount = (cents / 100);
    const two = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const zero = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, two)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, zero)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, zero.replace(/,/g, '.'));
  };
  window.MDC.money = money;

  /* ---------- Toast ---------- */
  const toast = (msg, ms = 2600) => {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-visible'), ms);
  };
  window.MDC.toast = toast;

  /* ---------- Curtain: preloader + page transitions ---------- */
  const curtain = $('#Curtain');
  const openCurtain = () => {
    if (!curtain) return;
    curtain.classList.add('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(() => curtain.classList.add('is-done'), 1200);
  };
  if (curtain) {
    const seen = sessionStorage.getItem('mdc_curtain');
    if (!MDC.settings.curtain || reduceMotion || seen) {
      // Short open on subsequent pages (page transition landing)
      if (!seen) curtain.classList.add('is-instant');
      requestAnimationFrame(() => setTimeout(openCurtain, seen ? 80 : 0));
    } else {
      document.body.classList.add('is-locked');
      const bar = $('.curtain__bar i', curtain);
      let p = 0;
      const tick = setInterval(() => { p = Math.min(92, p + Math.random() * 18); if (bar) bar.style.width = p + '%'; }, 160);
      const done = () => { clearInterval(tick); if (bar) bar.style.width = '100%'; setTimeout(openCurtain, 350); sessionStorage.setItem('mdc_curtain', '1'); };
      if (document.readyState === 'complete') setTimeout(done, 900); else window.addEventListener('load', () => setTimeout(done, 400));
      setTimeout(done, 2400); // never trap the visitor
    }
    // Page transitions
    if (MDC.settings.transitions && !reduceMotion) {
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href]');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.hasAttribute('download')) return;
        const url = new URL(a.href, location.href);
        if (url.origin !== location.origin || url.pathname === location.pathname && url.hash) return;
        if (a.closest('[data-no-transition]') || a.hasAttribute('data-no-transition')) return;
        e.preventDefault();
        curtain.classList.remove('is-open', 'is-instant', 'is-done');
        curtain.classList.add('is-closing');
        setTimeout(() => { location.href = url.href; }, 560);
      });
      window.addEventListener('pageshow', (e) => { if (e.persisted) { curtain.classList.remove('is-closing'); openCurtain(); } });
    }
  }

  /* ---------- Cursor ---------- */
  const cursor = $('.cursor');
  if (cursor && isFine && !reduceMotion) {
    let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y, raf;
    const label = $('.cursor__label', cursor);
    const loop = () => { cx += (x - cx) * 0.22; cy += (y - cy) * 0.22; cursor.style.transform = `translate(${cx}px,${cy}px)`; raf = requestAnimationFrame(loop); };
    loop();
    window.addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; cursor.classList.remove('is-hidden'); }, { passive: true });
    document.addEventListener('mouseleave', () => cursor.classList.add('is-hidden'));
    document.addEventListener('pointerover', (e) => {
      const t = e.target.closest('a, button, [data-cursor], input, select, textarea, label');
      const lbl = t && t.getAttribute('data-cursor');
      cursor.classList.toggle('is-hover', !!t);
      cursor.classList.toggle('is-label', !!lbl);
      if (label) label.textContent = lbl || '';
    });
  }

  /* ---------- Reveal on scroll + split text ---------- */
  const splitWords = (el) => {
    if (el.dataset.splitDone) return;
    const words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach((w, i) => {
      const wrap = document.createElement('span'); wrap.className = 'split__w';
      const inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--i', i);
      wrap.appendChild(inner); el.appendChild(wrap); el.appendChild(document.createTextNode(' '));
    });
    el.dataset.splitDone = '1';
  };
  $$('.split').forEach(splitWords);
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  $$('[data-reveal], .split').forEach((el) => io.observe(el));

  /* ---------- Marquee duration from width ---------- */
  $$('.marquee').forEach((m) => {
    const track = $('.marquee__track', m); if (!track) return;
    const speed = parseFloat(m.dataset.speed || '80'); // px per second
    const set = () => { m.style.setProperty('--marquee-speed', (track.scrollWidth / 2 / speed) + 's'); };
    set(); window.addEventListener('resize', set, { passive: true });
  });

  /* ---------- Header ---------- */
  const headerWrap = $('#HeaderWrap');
  if (headerWrap) {
    let last = 0;
    const onScroll = () => {
      const y = scrollY;
      headerWrap.classList.toggle('is-scrolled', y > 24);
      headerWrap.classList.toggle('is-hidden', y > last && y > 320 && !document.body.classList.contains('is-locked'));
      last = y;
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers / menu / scrim ---------- */
  const scrim = $('#Scrim');
  let openEl = null;
  const trapFocus = (el) => { const f = $('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])', el); if (f) setTimeout(() => f.focus(), 120); };
  const open = (id) => {
    const el = document.getElementById(id); if (!el) return;
    if (openEl && openEl !== el) close(true);
    el.classList.add('is-open'); el.removeAttribute('aria-hidden');
    scrim && scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    openEl = el; trapFocus(el);
    $$('[aria-controls="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    headerWrap && headerWrap.classList.toggle('is-menu-open', id === 'Menu');
  };
  const close = (keepLock) => {
    if (!openEl) return;
    const id = openEl.id;
    openEl.classList.remove('is-open'); openEl.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openEl = null;
    if (!keepLock) { scrim && scrim.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
    headerWrap && headerWrap.classList.remove('is-menu-open');
  };
  window.MDC.open = open; window.MDC.close = close;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); open(o.dataset.open); return; }
    const c = e.target.closest('[data-close]'); if (c) { e.preventDefault(); close(); }
  });
  scrim && scrim.addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeModal(); } });

  /* ---------- Modal ---------- */
  const closeModal = () => { $$('.modal.is-open').forEach((m) => { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }); if (!openEl) document.body.classList.remove('is-locked'); };
  const openModal = (id) => { const m = document.getElementById(id); if (!m) return; m.classList.add('is-open'); m.removeAttribute('aria-hidden'); document.body.classList.add('is-locked'); trapFocus(m); };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-modal]'); if (o) { e.preventDefault(); openModal(o.dataset.modal); return; }
    if (e.target.closest('[data-modal-close]') || (e.target.classList && e.target.classList.contains('modal'))) closeModal();
  });
  window.MDC.openModal = openModal;

  /* ---------- Magnetic buttons ---------- */
  if (isFine && !reduceMotion) {
    $$('[data-magnetic]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        el.style.transform = `translate(${dx * 10}px, ${dy * 10}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------- Rails: drag to scroll + nav buttons ---------- */
  $$('.rail').forEach((rail) => {
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', (e) => { if (!isFine) return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-dragging'); });
    window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; rail.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; rail.classList.remove('is-dragging'); });
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    const wrap = rail.closest('[data-rail]') || rail.parentElement;
    $$('[data-rail-prev]', wrap).forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' })));
    $$('[data-rail-next]', wrap).forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' })));
  });

  /* ---------- Videos: play in view, reels sound toggle ---------- */
  const vio = new IntersectionObserver((entries) => {
    entries.forEach((en) => { const v = en.target; if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); } });
  }, { threshold: 0.35 });
  $$('video[data-autoplay]').forEach((v) => { v.muted = true; v.playsInline = true; vio.observe(v); });
  $$('.reel').forEach((reel) => {
    const v = $('video', reel), btn = $('.reel__sound', reel), bar = $('.reel__progress i', reel);
    if (!v) return;
    btn && btn.addEventListener('click', () => { v.muted = !v.muted; btn.setAttribute('aria-pressed', String(!v.muted)); btn.classList.toggle('is-on', !v.muted); if (!v.muted) $$('.reel video').forEach((o) => { if (o !== v) o.muted = true; }); });
    if (bar) v.addEventListener('timeupdate', () => { bar.style.width = (v.currentTime / (v.duration || 1) * 100) + '%'; });
  });

  /* ---------- Countdowns ---------- */
  const pad = (n) => String(n).padStart(2, '0');
  const countdowns = $$('[data-countdown]');
  const UNIT_LABELS = { d: 'days', h: 'hours', m: 'min', s: 'sec' };
  const buildFlap = (el, units) => {
    el.innerHTML = units.map((u) => `<div class="flap__unit" data-unit="${u}"><div class="flap__digits"><span class="flap__digit">0</span><span class="flap__digit">0</span></div><span class="flap__label">${UNIT_LABELS[u]}</span></div>`).join('');
    el.dataset.built = '1';
  };
  const setFlap = (el, values) => {
    $$('.flap__unit', el).forEach((unit) => {
      const str = pad(values[unit.dataset.unit]);
      $$('.flap__digit', unit).forEach((dg, i) => {
        const ch = str[i];
        if (dg.textContent === ch) return;
        if (reduceMotion) { dg.textContent = ch; return; }
        dg.classList.remove('is-flipping'); void dg.offsetWidth; dg.classList.add('is-flipping');
        setTimeout(() => { dg.textContent = ch; }, 160);
      });
    });
  };
  const tickCountdowns = () => {
    const now = Date.now();
    countdowns.forEach((el) => {
      const t = new Date(el.dataset.countdown).getTime();
      let d = t - now;
      if (isNaN(t)) return;
      if (d <= 0) {
        if (!el.dataset.live) { el.dataset.live = '1'; el.classList.add('is-live'); el.innerHTML = `<span><b>${MDC.strings.liveNow || 'Live now'}</b></span>`; el.dispatchEvent(new CustomEvent('drop:live', { bubbles: true })); }
        return;
      }
      const days = Math.floor(d / 864e5); d -= days * 864e5;
      const h = Math.floor(d / 36e5); d -= h * 36e5;
      const m = Math.floor(d / 6e4); d -= m * 6e4;
      const s = Math.floor(d / 1e3);
      if (el.hasAttribute('data-flap')) {
        const units = (el.dataset.units || 'dhms').split('');
        if (!el.dataset.built) buildFlap(el, units);
        setFlap(el, { d: days, h, m, s });
        return;
      }
      el.innerHTML = `<span>${pad(days)}<small>d</small></span><span>${pad(h)}<small>h</small></span><span>${pad(m)}<small>m</small></span><span>${pad(s)}<small>s</small></span>`;
    });
  };
  // "Remind me": hand the visitor an .ics for the drop
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ics]'); if (!b) return;
    const start = new Date(b.dataset.icsStart); if (isNaN(start)) return;
    const fmt = (dt) => dt.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const end = new Date(start.getTime() + 36e5);
    const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Maison de Chris//Velvet Room//EN', 'BEGIN:VEVENT', `UID:${start.getTime()}@maisondechris.com`, `DTSTAMP:${fmt(new Date())}`, `DTSTART:${fmt(start)}`, `DTEND:${fmt(end)}`, `SUMMARY:${b.dataset.icsTitle}`, `DESCRIPTION:The curtain lifts. ${b.dataset.icsUrl}`, `URL:${b.dataset.icsUrl}`, 'BEGIN:VALARM', 'TRIGGER:-PT30M', 'ACTION:DISPLAY', 'DESCRIPTION:Maison de Chris drops in 30 minutes', 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
    const a = document.createElement('a'); a.href = url; a.download = 'maison-de-chris-drop.ics'; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    toast('Added to your calendar. See you at 20:00.');
  });
  if (countdowns.length) { tickCountdowns(); setInterval(tickCountdowns, 1000); }
  document.addEventListener('drop:live', (e) => { const locked = e.target.closest('.product__locked'); if (locked) { locked.hidden = true; $$('[data-atc-locked]').forEach((b) => { b.hidden = false; }); } });

  /* ---------- Cart ---------- */
  const cartDrawer = $('#CartDrawer');
  const renderSections = (sections) => {
    if (!sections) return;
    if (sections['cart-drawer'] && cartDrawer) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const next = $('#CartDrawer', html);
      if (next) { cartDrawer.innerHTML = next.innerHTML; initQty(cartDrawer); }
    }
    if (sections['main-cart']) {
      const html = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      const cur = $('#MainCart'), next = $('#MainCart', html);
      if (cur && next) { cur.innerHTML = next.innerHTML; initQty(cur); }
    }
  };
  const setCount = (n) => { $$('.cart-count').forEach((c) => { c.textContent = n; c.dataset.count = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }); };
  const cartFetch = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
    return data;
  };
  const sectionsList = () => ['cart-drawer', $('#MainCart') ? 'main-cart' : null].filter(Boolean).join(',');
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form); const label = btn ? btn.innerHTML : '';
    btn && (btn.disabled = true, btn.innerHTML = '<span>…</span>');
    try {
      const fd = new FormData(form);
      const body = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10), properties: {} }], sections: sectionsList() };
      const data = await cartFetch(MDC.routes.cartAdd + '.js', body);
      renderSections(data.sections);
      const cart = await (await fetch(MDC.routes.cart + '.js')).json();
      setCount(cart.item_count);
      if (cartDrawer) open('CartDrawer'); else toast(MDC.strings.added || 'Added to bag');
    } catch (err) { toast(err.message); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = label; } }
  });
  const changeLine = async (key, quantity, lineEl) => {
    lineEl && lineEl.classList.add('is-loading');
    try {
      const data = await cartFetch(MDC.routes.cartChange + '.js', { id: key, quantity, sections: sectionsList() });
      renderSections(data.sections); setCount(data.item_count);
    } catch (err) { toast(err.message); lineEl && lineEl.classList.remove('is-loading'); }
  };
  const initQty = (root) => {
    $$('[data-line]', root).forEach((line) => {
      const key = line.dataset.line, input = $('input[name="quantity"]', line);
      $$('[data-qty]', line).forEach((b) => b.addEventListener('click', () => { const q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(b.dataset.qty, 10)); changeLine(key, q, line); }));
      input && input.addEventListener('change', () => changeLine(key, Math.max(0, parseInt(input.value || '0', 10)), line));
      $$('[data-remove]', line).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); changeLine(key, 0, line); }));
    });
    const note = $('[data-cart-note]', root);
    note && note.addEventListener('change', () => cartFetch(MDC.routes.cartUpdate + '.js', { note: note.value }).catch(() => {}));
  };
  initQty(document);

  /* ---------- Product form: variants, media, price, locks ---------- */
  $$('[data-product]').forEach((root) => {
    const form = $('form[data-product-form]', root);
    const data = $('[data-variants]', root);
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root), stickyPrice = $('[data-sticky-price]', root);
    const atc = $('[data-atc]', root), atcText = $('[data-atc-text]', root);
    const optionInputs = () => $$('input[type="radio"][data-option]', root);
    const selected = () => { const o = {}; optionInputs().forEach((i) => { if (i.checked) o[i.dataset.option] = i.value; }); return o; };
    const find = () => { const sel = selected(); return variants.find((v) => v.options.every((val, i) => sel['option' + (i + 1)] === val)); };
    const pricePending = (v) => v && v.price === 0;
    const update = (push) => {
      const v = find();
      const sel = selected();
      // availability shading on size pills for the chosen colour
      $$('input[data-option="option2"]', root).forEach((i) => {
        const match = variants.find((x) => x.option1 === sel.option1 && x.option2 === i.value);
        const pill = i.nextElementSibling; if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
      });
      $$('[data-option-value="option1"]', root).forEach((el) => { el.textContent = sel.option1 || ''; });
      $$('[data-option-value="option2"]', root).forEach((el) => { el.textContent = sel.option2 || ''; });
      if (!v) { if (atc) { atc.disabled = true; atcText.textContent = MDC.strings.unavailable; } return; }
      idInput.value = v.id;
      const priceHtml = pricePending(v) ? `<span class="price--pending">${MDC.settings.pricePending}</span>` : (v.compare_at_price > v.price ? `<span class="price__compare">${money(v.compare_at_price)}</span><span class="price__sale">${money(v.price)}</span>` : money(v.price));
      if (priceEl) priceEl.innerHTML = priceHtml; if (stickyPrice) stickyPrice.innerHTML = priceHtml;
      if (atc) {
        const locked = root.dataset.locked === 'true' || pricePending(v);
        atc.disabled = locked || !v.available;
        atcText.textContent = !v.available ? MDC.strings.soldOut : (pricePending(v) ? MDC.settings.pricePending : MDC.strings.addToBag);
      }
      // media: scroll gallery to the variant image
      if (v.featured_media && v.featured_media.id) {
        const target = $(`[data-media-id="${v.featured_media.id}"]`, root);
        if (target && push) {
          const gallery = target.closest('.gallery');
          if (gallery && getComputedStyle(gallery).display === 'flex') gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          else target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      }
      // gallery filtering by colour alt text
      const colour = (sel.option1 || '').toLowerCase();
      const items = $$('.gallery__item[data-alt]', root);
      if (colour && items.length) {
        const matching = items.filter((it) => it.dataset.alt.toLowerCase().includes(' in ' + colour));
        if (matching.length) items.forEach((it) => it.classList.toggle('is-hidden', !matching.includes(it)));
      }
      if (push && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    };
    optionInputs().forEach((i) => i.addEventListener('change', () => update(true)));
    update(false);
    // sticky ATC on mobile
    const sticky = $('.sticky-atc', root), ctaBlock = $('.product__cta', root);
    if (sticky && ctaBlock) {
      const sio = new IntersectionObserver((en) => sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0), { threshold: 0 });
      sio.observe(ctaBlock);
      $('[data-sticky-go]', sticky) && $('[data-sticky-go]', sticky).addEventListener('click', () => ctaBlock.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
    // apply recommended size
    applyRecommendedSize(root);
  });

  /* ---------- Find My Size ---------- */
  const SIZES = ['S', 'M', 'L', 'XL'];
  // A saved size matches single sizes, combined sizes (S/M, L/XL) and Free Size.
  const sizeMatches = (saved, value) => {
    const v = (value || '').trim().toUpperCase();
    return v === saved || v === 'FREE SIZE' || v === 'ONE SIZE' || (v === 'S/M' && (saved === 'S' || saved === 'M')) || (v === 'L/XL' && (saved === 'L' || saved === 'XL'));
  };
  const recommend = ({ height, weight, fit, category }) => {
    // Heuristic built on the Maison de Chris size charts (cm/kg); tuned for S–XL.
    const bmi = weight / Math.pow(height / 100, 2);
    let idx = bmi < 19.8 ? 0 : bmi < 22.4 ? 1 : bmi < 25 ? 2 : 3;
    if (height >= 176 && idx < 3) idx += 0.5; // taller frames size up on length
    if (fit === 'fitted') idx -= 0.5; if (fit === 'relaxed') idx += 0.5;
    if (category === 'bottoms' && bmi >= 23 && idx < 3) idx += 0.25;
    idx = Math.min(3, Math.max(0, Math.round(idx)));
    const confidence = Math.abs(bmi - [18.8, 21.1, 23.7, 26.5][idx]) < 1.1 ? 'high' : 'good';
    return { size: SIZES[idx], confidence };
  };
  const applyRecommendedSize = (root) => {
    const saved = localStorage.getItem('mdc_size'); if (!saved) return;
    $$('input[data-option="option2"]', root || document).forEach((i) => { const p = i.nextElementSibling; p && p.classList.toggle('is-recommended', sizeMatches(saved, i.value)); });
    $$('.size-table tr', root || document).forEach((tr) => tr.classList.toggle('is-recommended', sizeMatches(saved, tr.dataset.size || '') && (tr.dataset.size || '').toUpperCase() !== 'SIZE'));
    $$('[data-your-size]').forEach((el) => { el.textContent = saved; el.closest('[data-your-size-wrap]') && (el.closest('[data-your-size-wrap]').hidden = false); });
  };
  const sizer = $('#SizeFinder');
  if (sizer) {
    const form = $('form', sizer), result = $('.sizer__result', sizer);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const height = parseFloat(fd.get('height')), weight = parseFloat(fd.get('weight'));
      if (!(height > 120 && height < 220 && weight > 30 && weight < 180)) { toast('Please enter height in cm and weight in kg.'); return; }
      const r = recommend({ height, weight, fit: fd.get('fit') || 'regular', category: sizer.dataset.category || 'tops' });
      localStorage.setItem('mdc_size', r.size);
      localStorage.setItem('mdc_size_inputs', JSON.stringify({ height, weight, fit: fd.get('fit') }));
      $('[data-sizer-size]', result).textContent = r.size;
      $('[data-sizer-note]', result).textContent = r.confidence === 'high' ? 'A confident match on our chart.' : 'Between sizes? The notes under each size will help.';
      result.hidden = false;
      applyRecommendedSize();
      const chosen = $$('input[data-option="option2"]').find((i) => sizeMatches(r.size, i.value) && !i.nextElementSibling.classList.contains('is-unavailable'));
      if (chosen && !chosen.nextElementSibling.classList.contains('is-unavailable')) { chosen.checked = true; chosen.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    try { const prev = JSON.parse(localStorage.getItem('mdc_size_inputs') || 'null'); if (prev) { form.height.value = prev.height; form.weight.value = prev.weight; const f = $(`input[name="fit"][value="${prev.fit}"]`, form); f && (f.checked = true); } } catch (e) {}
  }
  applyRecommendedSize();

  /* ---------- Predictive search ---------- */
  const searchInput = $('#SearchDrawer input[type="search"]'), searchResults = $('#SearchResults');
  if (searchInput && searchResults) {
    let t;
    searchInput.addEventListener('input', () => {
      clearTimeout(t); const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${MDC.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&section_id=predictive-search`);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('#PredictiveResults', doc); searchResults.innerHTML = inner ? inner.innerHTML : '';
        } catch (e) {}
      }, 220);
    });
  }

  /* ---------- Collection filters (AJAX) ---------- */
  const filterForm = $('#FilterForm');
  if (filterForm) {
    let t;
    const sectionId = filterForm.dataset.section;
    const apply = async (url) => {
      const grid = $('#CollectionResults'); grid && grid.classList.add('is-loading');
      const u = new URL(url, location.href); u.searchParams.set('section_id', sectionId);
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['#CollectionResults', '#ActiveFilters', '#ResultsCount', '#FilterForm'].forEach((sel) => { const a = $(sel), b = $(sel, doc); if (a && b) a.innerHTML = b.innerHTML; });
      grid && grid.classList.remove('is-loading');
      $$('[data-reveal]', grid || document).forEach((el) => el.classList.add('is-in'));
      history.pushState({}, '', url);
    };
    const serialize = () => { const fd = new FormData(filterForm); const p = new URLSearchParams(); for (const [k, v] of fd.entries()) if (v !== '') p.append(k, v); return `${location.pathname}?${p.toString()}`; };
    filterForm.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => apply(serialize()), 180); });
    document.addEventListener('click', (e) => { const a = e.target.closest('[data-filter-link]'); if (a) { e.preventDefault(); apply(a.href); } });
    window.addEventListener('popstate', () => apply(location.href));
    $$('[data-grid-cols]').forEach((b) => b.addEventListener('click', () => { const g = $('#CollectionResults .product-grid'); if (!g) return; $$('[data-grid-cols]').forEach((x) => x.setAttribute('aria-pressed', 'false')); b.setAttribute('aria-pressed', 'true'); g.classList.toggle('product-grid--2', b.dataset.gridCols === '2'); }));
  }

  /* ---------- Accordion smooth open ---------- */
  $$('.accordion details, .filters details').forEach((d) => {
    const body = d.querySelector('.accordion__body, .filters__body'); if (!body || reduceMotion) return;
    d.addEventListener('toggle', () => { if (d.open) { body.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 350, easing: 'cubic-bezier(.16,1,.3,1)' }); } });
  });

  /* ---------- Newsletter inline feedback ---------- */
  if (location.search.includes('customer_posted=true')) { toast('You are on the list. Welcome to the house.'); }
})();
